<template>
  <div class="new">
    <div class="new__title">
      <template v-if="type === 'new'">
        新建产品信息
      </template>
      <template v-else>
        产品信息
      </template>
    </div>
    <div class="new-top">
      <div class="new-top__text">产品信息</div>
      <div class="new-top__tips">* 带星号项为必填项</div>
    </div>
    <div class="new-module">
      <div class="new-module__title">产品基本信息</div>
      <div class="new-module-item">
        <div class="new-module-block">
          <div class="new-module-list__name" style="text-align: start;">
            <span class="new-module-list__star">*</span>
            产品图片
          </div>
          <div class="new-module-img" :class="{'new-module-list__input--prompt': isPrompt && !product.img}">
            <template v-if="!product.img">
              <div class="new-module-img__add"></div>
              <input type="file" id="image" class="new-module-img__input" @change="uploadImg()">
              <div class="new-module-img__text">（图片大小不超过1024KB，仅限JPG、JEPG和PNG格式）</div>
            </template>
            <template v-else>
              <div class="new-module-img__close" @click="removeImg()"></div>
              <img :src="'/api/support-server/v1/fileInfo/downloadFile/' + product.img" alt="" class="new-module-img__image">
            </template>
          </div>
        </div>
        <div class="new-module-block" v-for="(item, index) in basicInfoInputModule" :key="index">
          <div class="new-module-list" v-for="itemIndex in item" :key="itemIndex.data">
            <div class="new-module-list__name">
              <span class="new-module-list__star" v-if="itemIndex.isRequired">*</span>
              {{ itemIndex.name }}：
            </div>
            <div class="new-module-list__input"
              :class="{
                'new-module-list__input--size' : itemIndex.data === 'size' || itemIndex.data === 'boxSize',
                'new-module-list__input--prompt': isPrompt && itemIndex.isRequired && !(itemIndex.data === 'size' || itemIndex.data === 'boxSize') && (product[itemIndex.data] == '' || product[itemIndex.data] == undefined)
              }">
              <template v-if="itemIndex.data === 'productStatus'">
                <el-select
                  size="mini"
                  popper-class="productStatusSelect"
                  ref="productStatusSelect"
                  :placeholder="itemIndex.pla"
                  :disabled="itemIndex.isDisable ||isDisable"
                  v-model="product[itemIndex.data]"
                  collapse-tags
                  multiple>
                  <div class="new-module-list__input-status">
                    <div class="new-module-list__input-module">
                      <div class="new-module-list__input-module__title">
                        必选项1
                        <span class="new-module-list__input-module__tip">(单选)</span>
                      </div>
                      <el-option
                        v-for="option in itemIndex.array.slice(0, 3)"
                        :key="option"
                        :label="option"
                        :value="option">
                        <el-checkbox
                          :label="option"
                          :value="judgeStatusCheckBox(option)"
                          @change="statusCheckChange($event, option)"></el-checkbox>
                      </el-option>
                    </div>
                    <div class="new-module-list__input-module">
                      <div class="new-module-list__input-module__title">
                        必选项2
                        <span class="new-module-list__input-module__tip">(单选)</span>
                      </div>
                      <el-option
                        v-for="option in itemIndex.array.slice(3, 6)"
                        :key="option"
                        :label="option"
                        :value="option">
                        <el-checkbox
                          :label="option"
                          :value="judgeStatusCheckBox(option)"
                          @change="statusCheckChange($event, option)"></el-checkbox>
                        </el-option>
                    </div>
                    <div class="new-module-list__input-module">
                      <div class="new-module-list__input-module__title">
                        非必选项
                        <span class="new-module-list__input-module__tip">(可多选,请如实勾选)</span>
                        <el-option
                          v-for="option in itemIndex.array.slice(6, 9)"
                          :key="option"
                          :label="option"
                          :value="option">
                          <el-checkbox
                            :label="option"
                            :value="judgeStatusCheckBox(option)"
                            @change="statusCheckChange($event, option)"></el-checkbox>
                        </el-option>
                      </div>
                    </div>
                  </div>
                </el-select>
              </template>
              <template v-else-if="itemIndex.data === 'size'">
                <el-input
                  size="mini"
                  type="number"
                  v-for="input in productSizeInputData"
                  :key="input.data"
                  :class="{'new-module-list__input--prompt': isPrompt && itemIndex.isRequired && product[input.data] == ''}"
                  :disabled="itemIndex.isDisable ||isDisable"
                  :placeholder="input.pla"
                  v-model="product[input.data]"></el-input>
              </template>
              <template v-else-if="itemIndex.data === 'boxSize'">
                <el-input
                  size="mini"
                  type="number"
                  v-for="input in boxSizeInputData"
                  :key="input.data"
                  :class="{'new-module-list__input--prompt': isPrompt && itemIndex.isRequired && product[input.data] == ''}"
                  :disabled="itemIndex.isDisable ||isDisable"
                  :placeholder="input.pla"
                  v-model="product[input.data]"></el-input>
              </template>
              <template v-else-if="itemIndex.type == 'select'">
                <el-select
                  v-model="product[itemIndex.data]"
                  size="mini"
                  :disabled="itemIndex.isDisable ||isDisable"
                  :placeholder="itemIndex.pla">
                  <el-option
                    v-for="(option, index) in itemIndex.array"
                    :key="index"
                    :value="index"
                    :label="option"></el-option>
                </el-select>
              </template>
              <template v-else>
                <el-input
                  size="mini"
                  :type="itemIndex.type"
                  v-model="product[itemIndex.data]"
                  :disabled="itemIndex.isDisable ||isDisable"
                  :placeholder="itemIndex.pla"></el-input>
              </template>
            </div>
            <div class="new-module-list__unit">{{ itemIndex.unit }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="new-module">
      <div class="new-module__title">
        产品供应商
        <div class="new-module__tips">(备注: 如果您们自己就是产品的生产供应商,“供应商”可默认选择自己公司)</div>
      </div>
      <div class="new-module-item">
        <div class="new-module-list">
          <div class="new-module-list__name">
            <span class="new-module-list__star">*</span>
            供应商：
          </div>
          <div class="new-module-list__input">
            <el-select
              size="mini"
              v-model="product.supplierId"
              :class="{'new-module-list__input--prompt': isPrompt && product.supplierId == ''}"
              :disabled="isDisable"
              :placeholder="''">
              <el-option v-show="false" value="1"></el-option>
              <div class="new-module-list__input-supplier">
                <div class="new-module-list__input-supplier__btn">创建薪的供应商</div>
                <div class="new-module-list__input-supplier__text">选择已建供应商</div>
              </div>
              <el-option
                v-for="item in supplierList"
                :key="item.value"
                :value="item.value"
                :label="item.label"></el-option>
            </el-select>
          </div>
        </div>
        <div class="new-module-list">
          <div class="new-module-list__name">
            <span class="new-module-list__star">*</span>
            采购单价：
          </div>
          <div class="new-module-list__input">
            <el-input
              size="mini"
              type="number"
              prefix-icon="icon-el-inco-cmoney"
              :class="{'new-module-list__input--prompt': isPrompt && product.purchasePrice == ''}"
              :disabled="isDisable"
              v-model="product.purchasePrice"></el-input>
          </div>
        </div>
      </div>
    </div>
    <div class="new-module">
      <div class="new-module__title">
        出口产品补充信息
        <div class="new-module__tips">(备注:非出口产品无需要填写;此处为了后续的出口单证自动生成及提高操作效率)</div>
      </div>
      <div class="new-module-item">
        <div class="new-module-block" v-for="(item, index) in exportInfoInputModule" :key="index">
          <div class="new-module-list" v-for="(itemIndex, index) in item" :key="itemIndex.data + index">
            <div class="new-module-list__name">
              <template v-if="index !== 'empty'">
                <span class="new-module-list__star" v-if="itemIndex.isRequired">*</span>
                {{ itemIndex.name }}
                <span class="new-module-list__tips">{{ itemIndex.tips }}</span>：
              </template>
            </div>
            <div class="new-module-list__input" :class="{'new-module-list__input--remark': itemIndex.data === 'remarks'}">
              <template v-if="index !== 'empty'">
                <el-input
                  size="mini"
                  :type="itemIndex.type"
                  :prefix-icon="itemIndex.preUnit"
                  v-model="product[itemIndex.data]"
                  :class="{'new-module-list__input--prompt': isPrompt && itemIndex.isRequired && product[itemIndex.data] == ''}"
                  :disabled="itemIndex.isDisable ||isDisable"
                  :placeholder="itemIndex.pla"></el-input>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="new-bottom">
      <template v-if="type === 'new'">
        <div class="new-bottom__btn" @click="saveTemp">临时保存</div>
        <div class="new-bottom__btn" @click="newProduct">新建</div>
      </template>
      <template v-if="type === 'change'">
        <template v-if="isDisable">
          <div class="new-bottom__btn" @click="changeBtnCLick">修改</div>
        </template>
        <template v-else>
          <div class="new-bottom__btn" @click="updateProduct">保存</div>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import { Product, ProductNewModule } from './class'
import { SummaryNewModule, summaryTab } from "common/dataClass/Summary";
import { SupplierOption } from "common/dataClass/Supplier";
import globalData from 'common/globalData'
import ProductAxios from 'service/product'
import SupplierAxios from 'service/supplier'
import DefaultAxios from 'service/default'
export default {
  name: 'newProductInfo',
  data(){
    return {
      /**是否可修改 */
      isDisable: false,
      /**产品数据 */
      product: new Product(),
      /**产品基本信息 */
      basicInfoInputModule: ProductNewModule.NEWBASICINFO(),
      /**出口信息 */
      exportInfoInputModule: ProductNewModule.NEWEXPORTINFO(),
      /**产品状态 */
      productStatusInputOptions: globalData.logisticsStatusInputOptions,
      /**包装尺寸 */
      productSizeInputData: ProductNewModule.NEWSIZE(),
      boxSizeInputData: ProductNewModule.NEWBOXSIZE(),
      /**供应商数据列表 */
      supplierList: [],
      /**是否提示未输入数据 */
      isPrompt: false,
    }
  },
  methods: {
    /**上传图片 */
    async uploadImg(){
      /**图片最大限制 */
      let imgMaxSize = 1 * 1024 * 1024;
      let file = document.getElementById('image').files[0]
      if(file.size > imgMaxSize){
        this.$message.error('文件不能大于1M！')
        return
      }
      if(!/image\/\w+/.test(file.type)){
        this.$message.error('文件必须为图片！')
        return
      }
      if(!file) return;
      let res = await DefaultAxios.uploadImg(file)
      if(res.data.code === 1){
        this.$message.success('上传成功')
        this.product.img = res.data.info.fileId
      }
    },
    /**删除图片 */
    removeImg(){
      this.product.img = ''
    },
    /**产品状态select checkBox点击事件 */
    statusCheckChange(bool, label){
      let resultIndexArr = []
      let arr = this.product.productStatus
      if(!bool){
        arr.push(label)
      }else{
        arr = arr.filter(s => s != label)
      }
      arr = arr.map(v => this.productStatusInputOptions.indexOf(v))
      let battery = arr.filter(i => i >=0 && i <= 2).pop()
      let magnetic = arr.filter(i => i >=3 && i <= 5).pop()
      let otherArr = arr.filter(i => i >= 6)
      if(battery !== undefined) resultIndexArr.push(battery)
      if(magnetic !== undefined) resultIndexArr.push(magnetic)
      resultIndexArr = resultIndexArr.concat(otherArr)
      this.product.productStatus = resultIndexArr.map(i => this.productStatusInputOptions[i])
    },
    /**判断当前checkBox是否被选择 */
    judgeStatusCheckBox(label){
      return this.product.productStatus.includes(label)
    },
    /**返回产品管理页面 */
    returnListPage(){
      let functionMenu = SummaryNewModule.NEWFUNCTIONMENU()
      let tab = new summaryTab(
        functionMenu.product.list.productManagement.list.productInfo.name,
        functionMenu.product.list.productManagement.list.productInfo.id
      )
      this.$emit('delete', {id : 'newProductInfo', tab: tab})
    },
    /**临时保存按钮点击事件 */
    async saveTemp(){
      let res = await ProductAxios.getTemp(this.product.getSaveTempAxiosBody)
      if(res.data.code === 1){
        this.$message.success(res.data.info)
        this.returnListPage()
      }else{
        this.$message.error(res.data.info)
      }
    },
    /**修改按钮点击事件 */
    changeBtnCLick(){
      this.isDisable = false
    },
    /**新建产品 */
    async newProduct(){
      let keys = Object.keys(this.product)
      let noInputDataKey = ProductNewModule.NOINPUTDATA()
      this.isPrompt = true
      for(let key of keys){
        if(noInputDataKey.includes(key)){ continue; }
        if(!this.product[key] && this.product[key] !== 0){
          this.$message.error('请将数据补充完整')
          return;
        }
      }
      let obj = this.product.getSaveTempAxiosBody
      let res = await ProductAxios.newProduct(obj)
      if(res.data.info === 1){
        this.$message.success('新建成功')
        this.returnListPage()
      }else{
        this.$message.error(res.data.info)
      }
    },
    /**修改产品 */
    async updateProduct(){
      let keys = Object.keys(this.product)
      let noInputDataKey = ProductNewModule.NOINPUTDATA()
      this.isPrompt = true
      for(let key of keys){
        if(noInputDataKey.includes(key)){ continue; }
        if(!this.product[key] && this.product[key] !== 0){
          this.$message.error('请将数据补充完整')
          return;
        }
      }
      let obj = this.product.getUpdateProductAxiosBody
      let res = await ProductAxios.updateProduct(obj)
      if(res.data.info === 1){
        this.$message.success('修改成功')
        this.returnListPage()
      }else{
        this.$message.error(res.data.info)
      }
    }
  },
  computed:{
    type(){
      return this.$store.state.newProductInfo.type
    },
    id(){
      return this.$store.state.newProductInfo.id
    }
  },
  watch: {
    id:{
      immediate: true,
      async handler(newVal){
        this.isPrompt = false
        if(!newVal){
          this.product.init()
          this.isDisable = false
          return;
        }
        this.isDisable = true
        let res = await ProductAxios.getProductDetail(newVal)
        if(res.data.code !== 1) {
          this.$message.error(res.data.info)
          return;
        }
        let obj = res.data.info
        this.product.backendDetailDataParsing(obj)
      }
    }
  },
  async created(){
    let data = {
      "dateRange": null,
      "text": null
    }
    let res = await SupplierAxios.getList(data)
    if(res.data.code !== 1){
      this.$message.error(res.data.info)
      return;
    }
    let list = res.data.info
    this.supplierList.splice(0, this.supplierList.length)
    list.map(v => {
      this.supplierList.push(new SupplierOption(v.supplierId, v.supplierName))
    })
  }
}
</script>

<style lang="scss" scoped>
.new{
  width: 1800px;
  &__title{
    margin: 10px 10px 0;
    color: black;
    font-weight: bold;
    font-size: 18px;
  }
  &-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 5px 10px;
    border-bottom: 2px solid #00a0c7;
    &__text{
      padding: 6px 40px;
      background: #00a0c7;
      color: white;
      font-size: 14px;
    }
    &__tips{
      font-size: 12px;
      color: red;
    }
  }
  &-module{
    margin: 20px 80px;
    &__title{
      display: flex;
      align-items: end;
      color: #727272;
      font-weight: bolder;
      font-size: 18px;
    }
    &__tips{
      font-size: 14px;
      font-weight: normal;
      color: #00a0c7;
    }
    &-img{
      position: relative;
      margin-top: 10px;
      width: 200px;
      height: 200px;
      border: 1px solid #7f9db9;
      border-radius: 10px;
      &__add{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: inline-block;
        width: 76px;
        height: 76px;
        color: #ccc;
        position: relative;
        &::after, &::before{
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
        }
        &::before {
          width: 20px;
          border-top: 4px solid;
          margin: -2px 0 0 -10px;
        }
        &::after {
          height: 20px;
          border-left: 4px solid;
          margin: -10px 0 0 -2px;
        }
      }
      &__input{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 76px;
        height: 76px;
        opacity: 0;
        &:hover{
          cursor: pointer;
        }
      }
      &__image{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 180px;
        height: 180px;
      }
      &__text{
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        font-size: 12px;
        width: 180px;
        text-align: center;
      }
      &__close{
        position: absolute;
        top: 0;
        left: 90%;
        width: 20px;
        height: 20px;
        transform: rotate(45deg);
        transition: color .25s;
        display: inline-block;
        color: #ccc;
        position: relative;
        &:hover{
          color: #7f9db9;
          cursor: pointer;
        }
        &::after, &::before{
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
        }
        &::before {
          width: 16px;
          border-top: 2px solid;
          margin: -1px 0 0 -8px;
        }
        &::after {
          height: 16px;
          border-left: 2px solid;
          margin: -8px 0 0 -1px;
        }
      }
    }
    &-item{
      display: flex;
      margin: 10px ;
    }
    &-list{
      display: flex;
      height: 40px;
      line-height: 40px;
      margin-right: 50px;
      ::v-deep{
        .el-input__inner{
          border-radius: 0;
          width: 250px;
        }
      }
      &__input{
        width: 250px;
        display: flex;
        justify-content: space-between;
        ::v-deep{
          .icon-meiyuan_o{
            font-size: 14px;
            color: #409EFF;
          }
        }
        &-status{
          display: flex;
          padding: 5px 10px;
        }
        &-supplier{
          &__btn{
            padding: 5px 10px;
            font-size: 12px;
            color: #00a0c7;
            border-bottom: 1px solid #eeeeee;
            &:hover{
              cursor: pointer;
              opacity: .8;
            }
          }
          &__text{
            padding: 5px 10px;
            font-size: 12px;
            color: #00a0c7;
          }
        }
        &--size{
          ::v-deep{
            .el-input__inner{
              width: 80px;
            }
          }
          & > :last-child{
            margin-right: -4px;
          }
        }
        &--remark{
          ::v-deep{
            .el-input__inner{
              width: 720px;
            }
          }
        }
        &--prompt{
          border-color: red;
          ::v-deep{
            .el-input__inner{
              border-color: red;
            }
          }
        }
      }
      &__name{
        width: 170px;
        text-align: end;
      }
      &__star{
        color: red;
      }
      &__tips{
        color: #00a0c7;
      }
      &__unit{
        margin-left: 5px;
        font-size: 12px;
      }
    }
  }
  &-bottom{
    display: flex;
    justify-content: end;
    margin-right: 50px;
    &__btn{
      width: 120px;
      height: 30px;
      line-height: 30px;
      color: white;
      background: #00a0c7;
      text-align: center;
      margin: 0 10px;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
  }
}
</style>
